import * as React from "react";
import i18next from "i18next";
import { Map } from "ol";
import { useBaseMapContext } from "../../Contexts/BaseMapContext";
import { OpacityControl } from "./OpacityControl";
import { BaseMapsMode } from "../enums";
import { ToolbarButton } from "../Toolbar/ToolbarButton";
import { SplitControl } from "./SplitControl";
import { BasemapsSelectorPopup } from "./BasemapsSelectorPopup";
import { useMapContext } from "../../Contexts/MapContext";
import "./BasemapTools.scss";

export interface IBasemapToolbarButton {
    mode: BaseMapsMode;
}

export const BasemapTools = ({ map }: { map: Map }): JSX.Element => {
    const { widgetMode, secondaryMapId } = useBaseMapContext();

    return (
        <>
            <div className="basemap-toolbar">
                {widgetMode === BaseMapsMode.default ? <BasemapsToolbar /> : null}
                {widgetMode === BaseMapsMode.opacity ? <OpacityTool /> : null}
                {widgetMode === BaseMapsMode.swipe ? <SplitTool map={map} /> : null}
            </div>

            {!secondaryMapId && widgetMode !== BaseMapsMode.default ? <BasemapsSelectorPopup /> : null}
        </>
    );
};

const BasemapsToolbar = () => {
    const { configA } = useMapContext();
    const { setWidgetMode } = useBaseMapContext();
    return (
        <>
            {configA.widgets.SwipeWidgetEnabled ? (
                <ToolbarButton
                    iconClassName={"icon-geolite-map-split"}
                    onClick={() => setWidgetMode(BaseMapsMode.swipe)}
                    title={i18next.t("swipeButtonTooltip")}
                ></ToolbarButton>
            ) : null}
            {configA.widgets.MapOpacityWidgetEnabled ? (
                <ToolbarButton
                    iconClassName={"icon-geolite-overlay"}
                    onClick={() => setWidgetMode(BaseMapsMode.opacity)}
                    title={i18next.t("opacityButtonTooltip")}
                ></ToolbarButton>
            ) : null}
        </>
    );
};

const OpacityTool = () => {
    const { secondaryMapId, layerOpacity, setLayerOpacity } = useBaseMapContext();
    return (
        <>
            <OverlayCloseButton />
            {secondaryMapId ? (
                <OpacityControl id="opacity-input" value={layerOpacity} onChange={setLayerOpacity} />
            ) : null}
        </>
    );
};

const SplitTool = ({ map }) => {
    const { secondaryMapId } = useBaseMapContext();
    return (
        <>
            <OverlayCloseButton />
            {secondaryMapId ? <SplitControl map={map} /> : null}
        </>
    );
};

const OverlayCloseButton = () => {
    const { onOverlayMapClosed } = useBaseMapContext();
    return (
        <a
            role="button"
            className="toolbar-button unselectable"
            onClick={onOverlayMapClosed}
            title={i18next.t("close")}
        >
            <span className="icon-geolite-close"></span>
        </a>
    );
};
